

































































import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.min.css'

import { Drop } from 'vue-drag-drop'

import Component from 'vue-class-component'
import { ExtendedBlob } from '@/shared/models/extended-blob'
import { loggerFor } from '@/shared/utils/logger'
import { ImageDialogInput } from '@/main/image-dialog/image-dialog-input'
import { Hooks } from '@/shared/interfaces/hooks'
import { Prop } from 'vue-property-decorator'
import Dialog from '@/shared/dialog/dialog'
import { ImageDialogOutput } from '@/main/image-dialog/image-dialog-output'
import RespondecoDefaultModalFooter from '@/shared/components/prompt-dialog/respondeco-default-modal-footer.vue'
import { imageUrl } from '@/shared/utils/images'
import RespondecoToolbar from '@/shared/components/toolbar/respondeco-toolbar.vue'
import RespondecoToolbarItem from '@/shared/components/toolbar/respondeco-toolbar-item.vue'
import UnifyFormInput from '@/shared/components/unify/unify-form-input.vue'
import UnifyButton from '@/shared/components/unify/unify-button.vue'
import { BFormInput } from 'bootstrap-vue'
import RespondecoLoadingIndicator from '@/shared/components/respondeco-loading-indicator.vue'

@Component({
  components: {
    RespondecoLoadingIndicator,
    UnifyButton,
    UnifyFormInput,
    RespondecoToolbarItem,
    RespondecoToolbar,
    RespondecoDefaultModalFooter,
    Drop,
  },
})
export default class ImageDialog extends Dialog<ImageDialogOutput>
  implements ImageDialogInput, Hooks {
  @Prop({
    default: () => Number.NaN,
    type: Number,
  })
  public aspectRatio!: number

  @Prop({
    type: String,
  })
  public file?: string

  @Prop({
    default: 'image/jpeg',
    type: String,
  })
  public fileType!: string

  @Prop({
    default: 1,
    type: Number,
  })
  public viewMode!: number

  public activeImage?: string | ExtendedBlob
  public cropper!: Cropper

  public currentAspectRatio: number = this.aspectRatio

  public imageData: Cropper.ImageData | null = null

  private logger = loggerFor('ImageDialog')

  get prettyAspectRatio(): string {
    let ratio: string = ''

    if (Number.isNaN(this.currentAspectRatio) === true) {
      if (this.imageData != null) {
        ratio = this.imageData.aspectRatio.toFixed(3)
      }
    } else {
      ratio = this.currentAspectRatio.toFixed(3)
    }

    return ratio.replace('.', ',')
  }

  get freeAspectRatio(): boolean {
    return Number.isNaN(this.aspectRatio)
  }

  public data(): any {
    return {
      activeImage: '',
      cropper: undefined,
    }
  }

  public dismiss(): void {
    this.dialogRef.dismiss().close()
  }

  public handleDrop(data: any, event: any) {
    event.preventDefault()

    this.fromFile(event.dataTransfer.files[0])
  }

  public initialize(src: string | undefined = this.file) {
    this.logger.debug('Initialising with source: ', src)

    if (this.$refs.image && src) {
      this.activeImage = src

      const image: HTMLImageElement = this.$refs.image as HTMLImageElement

      image.src = imageUrl(src, 1920)

      this.cropper = new Cropper(image, {
        aspectRatio: this.aspectRatio,

        ready: () => {
          this.imageData = this.cropper.getImageData()
        },

        viewMode: this.viewMode,
      })
    }
  }

  public loadFile(event: any) {
    this.fromFile(event.target.files[0])
  }

  public reset(): void {
    this.cropper.reset()
  }

  public submit() {
    this.cropper
      .getCroppedCanvas({
        // fillColor: '#fff',
        height: 1080,
        maxHeight: 8192,
        maxWidth: 8192,
        width: 1920,
      })
      .toBlob((blob: Blob | null) => {
        if (blob != null) {
          this.dialogRef.submit(blob).close()
        }
      }, this.fileType)
  }

  public updateAspectRatio(aspectRatio: number) {
    this.currentAspectRatio = aspectRatio
    this.cropper.setAspectRatio(aspectRatio)
  }

  public updateAspectRatioFromInput() {
    const input = this.$refs.aspectRatio as BFormInput
    const ratioRegex = /^(\d+)[ ]*\/[ ]*(\d+)$/

    let ratio = this.currentAspectRatio

    if (ratioRegex.test(input.value) === true) {
      const match = ratioRegex.exec(input.value)

      if (match != null) {
        const left = parseInt(match[1], 10)
        const right = parseInt(match[2], 10)

        ratio = left / right
      }
    } else {
      ratio = parseFloat(input.value.replace(',', '.'))
    }

    if (Number.isNaN(ratio) === false) {
      this.updateAspectRatio(ratio)
    }
  }

  private fromFile(file: Blob) {
    this.activeImage = file

    const fileReader = new FileReader()

    fileReader.addEventListener('load', (event: any) => {
      if (this.cropper) {
        this.cropper.destroy()
      }

      this.initialize(event.target.result)
    })

    fileReader.readAsDataURL(file)
  }
}
